'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditorBody = require('./components/EditorBody.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditorBody).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-body/index.js
// module id = 1037
// module chunks = 0